import {Checkbox} from '@/components/commons/checkbox/ChekBox'
import {AgendaSidebarDottedDivider} from '@/features/agenda/components/agenda-sidebar-dotted-divider/AgendaSidebarDottedDivider'
import {useAgendaSearchHandlers} from '@/features/agenda/hooks/useAgendaSearchHandlers'
import {useAgendaSearchParams} from '@/features/agenda/hooks/useAgendaSearchParams'
import {AgendaUrlParams} from '@/features/agenda/types'
import {useTranslation} from '@/translations/i18n'
import {useEffect} from 'react'
import {useOutletContext} from 'react-router-dom'

export const AgendaHolidaysCheckbox = () => {
    const {t} = useTranslation()
    const {view} = useOutletContext<AgendaUrlParams>()
    const {searchParams} = useAgendaSearchParams()
    const {handleHideHolidays} = useAgendaSearchHandlers()

    useEffect(() => {
        const agendaCalendar = document.querySelector('.agenda-calendar')
        if (agendaCalendar) {
            if (!!searchParams.hideHolidays && view === 'week') {
                agendaCalendar.classList.add('hide-holidays')
            } else {
                agendaCalendar.classList.remove('hide-holidays')
            }
        }
    }, [searchParams.hideHolidays, view])

    if (view !== 'week') return null

    return (
        <>
            <AgendaSidebarDottedDivider />
            <Checkbox
                id="hide-holidays-checkbox"
                label={t('commons:hide_holidays')}
                checked={!!searchParams.hideHolidays}
                onChange={e => handleHideHolidays(e.target.checked)}
            />
            <AgendaSidebarDottedDivider />
        </>
    )
}
